import styled from 'styled-components';
import { textAlign } from 'styled-system';

export const TextAlign = styled.div<{ textAlign: string[] }>`
  ${textAlign};
`;
